var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mx-96 py-site lg:p-site"},[_c('FormWrapper',{attrs:{"formData":_vm.formData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }